import React from "react";
import Typography from '@mui/material/Typography';

const Products = () => {
    return (
        <Typography>
            Products
        </Typography>

    );
  };

  export default Products;